// This file is auto-generated.
export default {
    "version": "4.8.13",
    "buildDate": "2026-09-15 16:18:51",
    "buildPlatform": "vega",
    "buildBrandId": "cbs-news",
    "buildBundle": false,
    "buildEnv": "prod",
    "gql": {
        "endpoint": "https://helios-prod.cbssports.cloud"
    },
    "api": {
        "apiUrl": "https://video-api.cbssports.com/",
        "platformQuery": "vega",
        "diffFetchInterval": 15000,
        "shortCodeInterval": 10000,
        "maxRetryFallbackMs": 600000,
        "apiKey": "lyR2U37Sie80c02cJMpOH4C3gJety4LO1WnLA1FO",
        "apiPath": "vms",
        "geoApiUrl": "https://video-api-compute.cbssports.com/v2/dma.json",
        "rotatingSegmentTitlesApiUrl": "https://video-assets.cbssports.com/events/segment-title/v1.json",
        "logoUrlBase": "https://ottimg.cbssports.com/",
        "menuQuery": "56"
    },
    "log": {
        "enabled": false,
        "minLevel": 0
    },
    "analytics": {
        "utagUrl": {
            "env": "prod",
            "platformPath": "cbsnews-vega"
        },
        "fields": {
            "pageNameBase": "cbsnews/vega/",
            "siteHierBase": "cbsnews|vega|"
        }
    },
    "textToSpeech": {
        "allCapsTextToSplit": [
            "CBS"
        ],
        "dotTextToIgnore": []
    },
    "contactEmail": "support.cbsnews@cbsinteractive.com",
    "playback": {
        "idleToFullScreenMs": 8000,
        "idleToFullScreenWithActivityMs": 20000,
        "nowPlayingMsgDurationMs": 8000,
        "upNextMsgBeforeVideoEndMs": 8000,
        "ima": {
            "appName": "cbs news",
            "bundle": "cbs news",
            "descriptionUrl": "https://www.cbsnews.com/live/",
            "url": "cbs news",
            "appId": "cbsnews.vega",
            "iu": "/8264/vaw-news/ott/cbsnews_vega_tv_app",
            "csid": "vcbs_cbsnews_us_ctv_vega_live"
        },
        "drm": {
            "aes": {
                "provider": "irdeto.com"
            }
        },
        "debug": false
    },
    "featureFlags": {
        "enableParamountPlus": true
    },
    "ksDeviceType": "vega",
    "areYouStillWatching": {
        "noResponseTimeoutMs": 60000
    },
    "idleMode": {
        "idleTimeoutMs": 900000
    },
    "network": {
        "intervalDelay": 10000
    },
    "isDebug": false,
    "platformName": "vega",
    "subdomain": "ctv-vega-news",
    "fmsBundle": "cbsnews.vega",
    "privacy": {
        "organization": "cbs_news",
        "property": "cbs_news_amazon_vega"
    },
    "geoApiKey": "DiqWDIvQysKjaKqYKaELunHC5kV30DX5",
    "brand": {
        "id": "cbs-news",
        "name": "CBS News",
        "appId": "com.cbssports.app.ps4",
        "hostedDomain": "cbssports.com",
        "defaultNetworkName": "CBS News 24/7",
        "preGameDescription": "the latest headlines",
        "eventType": "event",
        "colors": {
            "default": 16410885,
            "splashSpinner": 16316664
        }
    },
    "appId": "com.cbssports.app.ps4",
    "appName": "CBS News"
};
